import http from './config'

export default {
  enviaTelefone: () => {
    return http.post('/api/v1/sms/envia-sms')
  },
  confirmaCodigoVerificador: (propostaBanco) => {
    return http.post('/api/v1/sms/confirma-codigo-verificador', propostaBanco)
  }
}
